import { handleActions } from 'redux-actions';
import { reduxKey } from '../constants';
import { reduxKey as writerKey } from '../../modals/WriterPopup/redux/constants';
import { WriterStoreSlice } from '../../modals/WriterPopup/redux/types';
import deviationsReducer from './deviations';
import presetsReducer from './presets';
import statusEditReducer from './statusEdit';
import originalsReducer from './originals';
import shippingProfilesReducer from './shippingProfiles';
import writerReducer, { defaultState as writerDefaultState } from './writer';
import { DeviationSubmitPopupStoreSlice } from '../types';

export default {
  [reduxKey as string]: handleActions<DeviationSubmitPopupStoreSlice, any>(
    {
      ...deviationsReducer,
      ...presetsReducer,
      ...statusEditReducer,
      ...originalsReducer,
      ...shippingProfilesReducer,
    },
    {
      formStatus: 'uninitialized',
      uploadStatus: {
        main: 'idle',
        pcp: 'idle',
        exclusive: 'idle',
      },
      scheduleTimestamp: undefined,
      presetsStatus: 'uninitialized',
      presetsPrompt: {},
      groupDestinations: {
        groupDestinations: [],
        inGroups: [],
        status: 'uninitialized',
        deviationId: 0,
      },
      statusEdit: {
        isSubmitting: false,
        statusId: null,
        error: '',
      },
    }
  ),
  [writerKey as string]: handleActions<WriterStoreSlice, any>(writerReducer, writerDefaultState),
};
